import React from 'react';
import { Button } from 'react-bootstrap';
import { MdWarning, MdCheck, MdClose } from 'react-icons/md';
import styled from 'styled-components';

const ConfirmContainer = styled.div`
  /* Modal centralizado acima do backdrop */
  .confirm-modal {
    position: fixed;
    top: 35vh;
    left: 50%;
    transform: translate(-50%, 0);
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    padding: 16px;
    width: 90vw;
    max-width: 460px;
    z-index: 9999;
  }

  .confirm-header {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #b91c1c; /* vermelho elegante */
    font-weight: 600;
    font-size: 1.05rem;
    margin-bottom: 8px;
  }

  .confirm-icon {
    color: #b91c1c;
    font-size: 1.1rem;
  }

  .confirm-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 8px 0 16px;
    border: 0;
  }
  .confirm-message {
    font-weight: 500;
    margin-bottom: 16px;
    color: #111827;
    text-align: center;
  }
  
  .confirm-buttons {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
  }

  .btn-outline-danger {
    border-color: #ef4444;
    color: #ef4444;
  }
  .btn-outline-danger:hover {
    background-color: #ef4444;
    color: #fff;
  }

  .btn-outline-success {
    border-color: #10b981;
    color: #10b981;
  }
  .btn-outline-success:hover {
    background-color: #10b981;
    color: #fff;
  }
`;

const ConfirmToast = ({ 
  title = 'Confirmação',
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Confirmar", 
  cancelText = "Cancelar",
  variant = "danger" 
}) => {
  return (
    <ConfirmContainer>
      {/* Caixa do diálogo centralizada */}
      <div className="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-header" aria-describedby="confirm-dialog-message">
        <div className="confirm-header" id='confirm-dialog-header'>
          <MdWarning className="confirm-icon" aria-hidden />
          <span>{title}</span>
        </div>
        <hr className="confirm-divider" />
        <div className="confirm-message" id='confirm-dialog-message'>{message}</div>
        <div className="confirm-buttons" id='confirm-dialog-actions'>
          <Button 
            size="sm" 
            variant="outline-success" 
            onClick={onConfirm}
            className="d-flex align-items-center"
            id='confirm-dialog-confirm'
          >
            <MdCheck className="me-1" />
            {confirmText}
          </Button>
          <Button 
            size="sm" 
            variant={variant === 'danger' ? 'outline-danger' : 'outline-secondary'}
            onClick={onCancel}
            className="d-flex align-items-center"
            id='confirm-dialog-cancel'
          >
            <MdClose className="me-1" />
            {cancelText}
          </Button>
        </div>
      </div>
    </ConfirmContainer>
  );
};

export default ConfirmToast;
